import Vue from 'vue'
import { API_ROOT } from '@/config'

const contextPath = 'user'

const customActions = {
  me: { method: 'GET', url: API_ROOT + contextPath + '/me' },
  myPasswordChange: { method: 'PUT', url: API_ROOT + 'user/me/password' }
}

export default (<any>Vue).resource(API_ROOT + contextPath + '{/id}', {}, customActions)
